import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

let sceneTextEnterH: any = null,
    sceneTextLeaveH: any = null;
export default function H() {
    const { useLang, useRouter, useEffect, useState, useRef, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('smart_home_panel_2.launch.detail');
    const video1RefPC = useRef();
    const video1RefH5 = useRef();
    const video2RefPC = useRef();
    const video2RefH5 = useRef();
    const [textEnter, setTextEnter] = useState(false);

    const [isH5, setIsH5] = useState();

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsH5(window?.innerWidth <= 1024);
        }
    }, []);

    // const Replay = (props: any) => (
    //     <svg className="replay-icon" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    //         <rect width="40" height="40" rx="20" fill="#707070" />
    //         <path d="M12.7271 10.9092L18.1816 10.9092L18.1816 16.3637" stroke="white" strokeWidth="1.81818" strokeLinecap="round" strokeLinejoin="round" />
    //         <path
    //             d="M22.7258 13.191C24.3989 13.7804 25.8351 14.8977 26.818 16.3743C27.8009 17.851 28.2773 19.6071 28.1753 21.378C28.0734 23.149 27.3987 24.8388 26.2529 26.1929C25.107 27.5471 23.5521 28.4921 21.8225 28.8857C20.0928 29.2794 18.2821 29.1002 16.6632 28.3752C15.0442 27.6502 13.7047 26.4187 12.8465 24.8663C11.9883 23.3139 11.6579 21.5245 11.905 19.768C12.1521 18.0114 12.9635 16.3827 14.2167 15.1274L18.1804 10.9092"
    //             stroke="white"
    //             strokeWidth="1.81818"
    //             strokeLinecap="round"
    //             strokeLinejoin="round"
    //         />
    //     </svg>
    // );

    // const handleReplay = (n: number) => {
    //     switch (n) {
    //         case 0:
    //             video1Ref.current.currentTime = 0;
    //             video1Ref.current.play();
    //             break;
    //         case 1:
    //             video2Ref.current.currentTime = 0;
    //             video2Ref.current.play();
    //             break;
    //         default:
    //             break;
    //     }
    // };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (sceneTextEnterH) {
                    AniContainer.removeScene(sceneTextEnterH);
                    sceneTextEnterH = null;
                }
                if (sceneTextLeaveH) {
                    AniContainer.removeScene(sceneTextLeaveH);
                    sceneTextLeaveH = null;
                }
                const clientH = (window.innerHeight || 0) * 0.2;
                const startH = Math.min(clientH, 150);
                sceneTextEnterH = AniContainer.create({
                    triggerElement: '.shp2-detail-H .text-info',
                    triggerHook: 1,
                    offset: startH,
                    duration: 200,
                    onEnter: () => setTextEnter(true),
                    //onLeave: () => setTextEnter(false),
                });
            };
            resizeAni();
            // window.addEventListener('resize', resizeAni);
            return () => {
                if (sceneTextEnterH) {
                    AniContainer.removeScene(sceneTextEnterH);
                    sceneTextEnterH = null;
                }
                if (sceneTextLeaveH) {
                    AniContainer.removeScene(sceneTextLeaveH);
                    sceneTextLeaveH = null;
                }

                // window.removeEventListener('resize', resizeAni);
            };
        }
    }, []);

    return (
        <section className={`shp2-detail-H shp2-detail-section ${css['shp2-detail-H']}`}>
            <div className={`text-info ${textEnter ? 'enter' : ''}`}>
                <p className="subtitle">{t('secH_subtitle')}</p>
                <h2 className="title">{t('secH_title')}</h2>
                <p className="desc">{t('secH_desc')}</p>
            </div>
            <div className="videos">
                <div className="video-list">
                    <div className="video-box">
                        {!isH5 && (
                            <video
                                src={'/responsive/video/smart-home-panel-2/launch/8_1_pc.mp4'}
                                className="video video1"
                                muted
                                loop
                                playsInline
                                autoPlay
                                preload="auto"
                                ref={video1RefPC}
                                aria-label={t('secH_video1_title')}
                                poster="/responsive/picture/smart-home-panel-2/launch/8_1.png"
                            />
                        )}
                        {isH5 && (
                            <video
                                src={'/responsive/video/smart-home-panel-2/launch/8_1_h5.mp4'}
                                className="video video1"
                                muted
                                loop
                                playsInline
                                autoPlay
                                preload="auto"
                                ref={video1RefH5}
                                aria-label={t('secH_video1_title')}
                                poster="/responsive/picture/smart-home-panel-2/launch/8_1.png"
                            />
                        )}
                        {/* <Replay onClick={() => handleReplay(0)} /> */}
                    </div>
                    <div className="video-info">
                        <p className="video-title">{t('secH_video1_title')}</p>
                        <p className="video-desc">
                            {t.rich('secH_video1_desc', {
                                w: (text: string) => <span className="white">{text}</span>,
                            })}
                        </p>
                    </div>
                </div>
                <div className="video-list">
                    <div className="video-box">
                        {!isH5 && (
                            <video
                                src={'/responsive/video/smart-home-panel-2/launch/8_2_pc.mp4'}
                                className="video video2"
                                muted
                                loop
                                playsInline
                                autoPlay
                                preload="auto"
                                ref={video2RefPC}
                                aria-label={t('secH_video2_title')}
                                poster="/responsive/picture/smart-home-panel-2/launch/8_2.png"
                            />
                        )}
                        {isH5 && (
                            <video
                                src={'/responsive/video/smart-home-panel-2/launch/8_2_h5.mp4'}
                                className="video video2"
                                muted
                                loop
                                playsInline
                                autoPlay
                                preload="auto"
                                ref={video2RefH5}
                                aria-label={t('secH_video2_title')}
                                poster="/responsive/picture/smart-home-panel-2/launch/8_2.png"
                            />
                        )}
                        {/* <Replay onClick={() => handleReplay(1)} /> */}
                    </div>
                    <div className="video-info">
                        <p className="video-title">{t('secH_video2_title')}</p>
                        <p className="video-desc">
                            {t.rich('secH_video2_desc', {
                                w: (text: string) => <span className="white">{text}</span>,
                            })}
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}
